/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import moment from "moment";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import NotificationsUI from "./NotificationsUI";
import NotificationsFormWrapper from "./NotificationsFormWrapper";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as pagesActions from "../../../actions/pagesActions";
import * as notificationsActions from "../../../actions/notificationsActions";
import * as topicsActions from "../../../actions/topicsActions";
import * as controlPanelActions from "../../../actions/controlPanelActions";
import ErrorHandler from "../../../helpers/validation/errorHandler";

class NotificationsPage extends Component {
	constructor(props) {
		super(props);
		this.appKey = this.props.match.params.appKey;
		this.state = {
			formApi: undefined,
		};
	}

	componentDidMount() {
		this.loadNotifications(this.appKey);
		this.props.topicsActions.loadTopics(this.appKey);
	}

	getApi = formApi => {
		this.setState({ formApi });
	};

	getAppId = key => {
		const { apps } = this.props;
		const app = apps.find(a => a.key === key);
		return app.id;
	};

	reloadNotifications = () => {
		const { notificationsActions, history } = this.props;
		notificationsActions.loadNotifications(this.appKey);
		history.push(`/apps/${this.appKey}/notifications`);
	};

	loadNotifications = appId => {
		this.props.notificationsActions.loadNotifications(appId);
	};

	logError = error => {
		ErrorHandler(error, this.state.formApi, this.props.controlPanelActions);
	};

	createItem = (values, submitHandler) => {
		const publishAt = moment.utc().format();
		const { globalActions } = this.props;
		const id = this.getAppId(this.appKey);
		const data = {
			...values,
			appId: id,
			publishAt: publishAt,
		};
		globalActions.createItem(data, "/notifications", this.reloadNotifications, this.logError, submitHandler);
	};

	updateItem = (values, submitHandler, itemId) => {
		//TODO: item to update has be different than what will be sent out
		const { globalActions } = this.props;
		globalActions.updateItem(
			values,
			`/notifications/${itemId}`,
			this.reloadNotifications,
			this.logError,
			submitHandler
		);
	};

	copyItem = (values, submitHandler) => {
		const publishAt = moment.utc().format();
		const { globalActions } = this.props;
		const id = this.getAppId(this.appKey);
		const data = {
			...values,
			appId: id,
			publishAt: publishAt,
		};
		globalActions.createItem(data, "/notifications", this.reloadNotifications, this.logError, submitHandler);
	};

	deleteItem = (id, name) => {
		let appKey = this.appKey;
		const { notificationsActions, globalActions } = this.props;
		const onSuccess = () => {
			notificationsActions.loadNotifications(appKey);
		};
		globalActions.deleteItem(`/notifications/${id}`, onSuccess, this.logError, name);
	};

	renderGrid = () => {
		const { notifications } = this.props.notifications;

		return (
			<div>
				{notifications ? (
					<div className="table-ui">
						<NotificationsUI
							appKey={this.appKey}
							update={this.updateItem}
							delete={this.deleteItem}
							items={notifications}
						/>
					</div>
				) : (
					<div></div>
				)}
			</div>
		);
	};

	render() {
		const { notifications } = this.props.notifications;

		return (
			<Page title="Notifications">
				{notifications ? (
					<GridFormSwitcher
						objectKey="Notifications"
						singleItemName="Notification"
						pluralItemName="Notifications"
						RenderCopy={NotificationsFormWrapper}
						RenderEdit={NotificationsFormWrapper}
						RenderNew={NotificationsFormWrapper}
						items={notifications}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
						loadPages={this.loadPages}
						topics={this.props.topics}
						getApi={this.getApi}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

NotificationsPage.propTypes = {
	match: PropTypes.any,
	notifications: PropTypes.object,
	actions: PropTypes.any,
	globalActions: PropTypes.any,
	history: PropTypes.object,
	apps: PropTypes.array,
	pagesActions: PropTypes.object,
	notificationsActions: PropTypes.object,
	topicsActions: PropTypes.object,
	topics: PropTypes.array,
	controlPanelActions: PropTypes.object,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
	notifications: state.notifications,
	topics: state.topics.topics,
});

const mapDispatchToProps = dispatch => ({
	notificationsActions: bindActionCreators(notificationsActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
	pagesActions: bindActionCreators(pagesActions, dispatch),
	topicsActions: bindActionCreators(topicsActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NotificationsPage);
